import { createRoute } from '@tanstack/react-router'

import { lockedScope } from '@shared/router/scope'

export const route = createRoute({
  getParentRoute: () => lockedScope,
  path: 'restricted-location',
})
